export const PLANNER_GET_CHALLENGES_BEGIN = 'PLANNER_GET_CHALLENGES_BEGIN';
export const PLANNER_GET_CHALLENGES_SUCCESS = 'PLANNER_GET_CHALLENGES_SUCCESS';
export const PLANNER_GET_CHALLENGES_FAILURE = 'PLANNER_GET_CHALLENGES_FAILURE';
export const PLANNER_GET_CHALLENGES_DISMISS_ERROR = 'PLANNER_GET_CHALLENGES_DISMISS_ERROR';
export const PLANNER_GET_REMINDERS_BEGIN = 'PLANNER_GET_REMINDERS_BEGIN';
export const PLANNER_GET_REMINDERS_SUCCESS = 'PLANNER_GET_REMINDERS_SUCCESS';
export const PLANNER_GET_REMINDERS_FAILURE = 'PLANNER_GET_REMINDERS_FAILURE';
export const PLANNER_GET_REMINDERS_DISMISS_ERROR = 'PLANNER_GET_REMINDERS_DISMISS_ERROR';
export const PLANNER_SET_READ_STATUS_BEGIN = 'PLANNER_SET_READ_STATUS_BEGIN';
export const PLANNER_SET_READ_STATUS_SUCCESS = 'PLANNER_SET_READ_STATUS_SUCCESS';
export const PLANNER_SET_READ_STATUS_FAILURE = 'PLANNER_SET_READ_STATUS_FAILURE';
export const PLANNER_SET_READ_STATUS_DISMISS_ERROR = 'PLANNER_SET_READ_STATUS_DISMISS_ERROR';
export const PLANNER_SET_FILTERED_BEGIN = 'PLANNER_SET_FILTERED_BEGIN';
export const PLANNER_SET_FILTERED_SUCCESS = 'PLANNER_SET_FILTERED_SUCCESS';
export const PLANNER_SET_FILTERED_FAILURE = 'PLANNER_SET_FILTERED_FAILURE';
export const PLANNER_SET_FILTERED_DISMISS_ERROR = 'PLANNER_SET_FILTERED_DISMISS_ERROR';
export const PLANNER_GET_STATS_BEGIN = 'PLANNER_GET_STATS_BEGIN';
export const PLANNER_GET_STATS_SUCCESS = 'PLANNER_GET_STATS_SUCCESS';
export const PLANNER_GET_STATS_FAILURE = 'PLANNER_GET_STATS_FAILURE';
export const PLANNER_GET_STATS_DISMISS_ERROR = 'PLANNER_GET_STATS_DISMISS_ERROR';
export const PLANNER_CREATE_CHALLENGE_BEGIN = 'PLANNER_CREATE_CHALLENGE_BEGIN';
export const PLANNER_CREATE_CHALLENGE_SUCCESS = 'PLANNER_CREATE_CHALLENGE_SUCCESS';
export const PLANNER_CREATE_CHALLENGE_FAILURE = 'PLANNER_CREATE_CHALLENGE_FAILURE';
export const PLANNER_CREATE_CHALLENGE_DISMISS_ERROR = 'PLANNER_CREATE_CHALLENGE_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/planner/redux/constants.js